const FETCH_PORTAL_CONFIGURATION_REQUEST = 'FETCH_PORTAL_CONFIGURATION_REQUEST';
const FETCH_PORTAL_CONFIGURATION_SUCCESS = 'FETCH_PORTAL_CONFIGURATION_SUCCESS';
const FETCH_PORTAL_CONFIGURATION_FAILURE = 'FETCH_PORTAL_CONFIGURATION_FAILURE';
const CLEAR_PORTAL_CONFIGURATION = 'CLEAR_PORTAL_CONFIGURATION';
const UPDATE_PORTAL_CONFIGURATION = 'UPDATE_PORTAL_CONFIGURATION';

export {
  FETCH_PORTAL_CONFIGURATION_REQUEST,
  FETCH_PORTAL_CONFIGURATION_SUCCESS,
  FETCH_PORTAL_CONFIGURATION_FAILURE,
  CLEAR_PORTAL_CONFIGURATION,
  UPDATE_PORTAL_CONFIGURATION,
};
